import React, {
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
// icons
import Book from "../../assets/icons/icon_book.gif";

// context
import { MyContext } from "../../context/MyContext";
// utils
import {
  backIncstance,
  checkGroupId,
  getLoginInfo,
} from "../../utils/commonFunctions";
import ndjsonStream from "can-ndjson-stream";
// hooks
import { UseViewToBottom } from "../../hooks/useScroll";

// components
import LoginModal from "./modal/LoginModal";
import Interview from "./components/Interview";
import ResultButtons from "./components/ResultButtons";
import Home from "./components/Home";
import Input from "./components/Input";
import Form from "./components/Form";
import { indexReducer, initialState } from "../../reducer";
import styled from "styled-components";
import CONSTANTS from "../../constants";

const URLS = {
  CLARIO: process.env.REACT_APP_SOCRATES_SERVER,
  CLARIO_GENERAL: process.env.REACT_APP_SOCRATES_GENERAL,
  START_INTERVIEW: process.env.REACT_APP_SOCRATES_STRAT_INTERVIEW,
  GROUP_RESULT: process.env.REACT_APP_SOCRATES_GET_GROUP_RESULT,
  STORAGE_RESULT: process.env.REACT_APP_SOCRATES_GET_STORAGE_RESULT,
  GET_KIND: process.env.REACT_APP_SOCRATES_GET_KIND,
  INTERESTING: process.env.REACT_APP_SOCRATES_GET_INTERESTING,
  GROUP_LIST: process.env.REACT_APP_SOCRATES_GET_GROUP_LIST, // 소크라테스 그룹 조회
  EDIT_GROUP_LIST: process.env.REACT_APP_SOCRATES_EDIT_GROUP_LIST, // 소크라테스 그룹 생성, 변경 및 삭제
  CHAT_HISTORY: process.env.REACT_APP_SOCRATES_GET_HISTORY_LIST, // 소크라테스 목록의 채팅 조회 및 체팅추가
  GET_STORAGE_LIST: process.env.REACT_APP_SOCRATES_GET_STORAGE_LIST, // 소크라테스 목록 조회
  EDIT_STORAGE: process.env.REACT_APP_SOCRATES_EDIT_STORAGE_LIST, // 소크라테스 보관함 채팅 목록 조회, 생성 및 변경
  STORAGE_LIST: process.env.REACT_APP_SOCRATES_GET_STOARGE_GROUP_LIST, // 소크라테스 보관함 채팅 목록 조회
  CLARIO_EVALUATION: process.env.REACT_APP_SOCRATES_EVALUATION, // 소크라테스 question_count당 평가 전송
  BACK_EVALUATION: process.env.REACT_APP_SOCRATES_SAVE_EAVALUTION,
  GET_FORM_LIST: process.env.REACT_APP_SOCRATES_GET_FORM,
  RESTART: process.env.REACT_APP_SOCRATES_RESTART,
};

const EMPTY = /^\s*$/;

const DEADLINE = 120;

/**
 * 컴포넌트 마운트시 param id 확인, 있을 때 로컬스토리지에 저장된 기본 정보로 핸들링
 * 1. params x => 소크라테스 폼 생성으로 연결
 * 2. params O, 면접 미완료, 대화 이력에 있는 대화일시 저장된 FORM (AI 통신 객체) 호출
 */

const Socrates = () => {
  const {
    user,
    isStartInterview,
    setIsStartInterview,
    isAddingMode,
    setIsAddingMode,
    setAlertSetting,
    setUser,
    clearState,
    history,
    setHistory,
    isUpdate,
    setIsUpdate,
    paramId,
    fetching,
    setFetching,
    isMobile,
    openNav,
    setList,
    isLogin,
    setIsLogin,
    isFreeScroll,
    setIsFreeScroll,
    setIsOpenTicketAlert,
  } = useContext(MyContext);

  const location = useLocation();
  const navigation = useNavigate();

  const triggerRef = useRef(false); // 사용자가 인터뷰 폼 클릭하거나 폼 작성 완료시 CLARIO 자동 호출, , ,
  const paramRef = useRef(location.pathname);
  const restartRef = useRef(false);
  const addRef = useRef(false);

  const scrollRef = UseViewToBottom(isUpdate); // scroll 영역 따라감
  const inputRef = useRef(null); // 사용자 입력값
  const timerRef = useRef(null);

  const [targetURL, setTartgetURL] = useState(URLS.CLARIO); // 샘플 면접과 일반 면접 AI endpoint 분기
  const [wordLng, setWordLng] = useState(0);
  const [isFocus, setIsFocus] = useState(false); // input창 focus 여부

  const [isVoiceMode, setIsVoiceMode] = useState(false); // voice mode

  // 유효한 로그인 상태인지 확인하는 함수
  const isValidLogin = () => {
    return !!(user && user.id);
  };

  const moveToLogin = () => {
    if (!isValidLogin()) {
      window.location.assign(
        `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}/socrates`
      );
    }
  };

  const handleTimer = (e) => {
    if (timerRef.current) {
      timerRef.current = false;
    }
  };
  // 사용자 입력값에 따라 입력 창 높이 조절
  const handleResizeHeight = () => {
    if (!inputRef.current) return;
    inputRef.current.style.height = "auto"; //height 초기화
    inputRef.current.style.height = inputRef.current.scrollHeight + "px";
  };

  /**
   * stram string 입력값 json data로 변경
   * @param {stream data} jsonString
   * @returns json object
   */
  const delayLoop = async (jsonString) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          resolve(jsonString);
        } catch (error) {
          reject(error);
        }
      }, 10); // 10ms 지연
    });
  };

  // 최초 질문으로 채팅방 제목 변경
  const updateTitle = async (id, text) => {
    // 제목이 20글자를 넘는 경우 잘라줍니다.
    const truncatedText = text.length > 20 ? text.substring(0, 20) : text;

    const resData = {
      group_id: id,
      title: truncatedText, // 잘린 제목으로 API 요청
    };

    const updateData = await touchAPI("PATCH", URLS.EDIT_GROUP_LIST, resData);
    if (updateData?.code === 200) {
      setList((prev) => {
        return prev.map((item) => {
          if (item.id === id) {
            return { ...item, title: truncatedText }; // 잘린 제목으로 상태 업데이트
          }
          return item;
        });
      });
    }
  };

  // AI 요청데이터 관리
  const [state, dispatch] = useReducer(indexReducer, initialState);
  /**
   * AI 답변 전송 및 질문 , CLARIO_EVALUATION 평가
   * @param {endpoint, CLARIO / CLARIO_EVALUATION} url
   */
  // const fetchData = async (url) => {
  //   // Reset input field if available

  //   const isStorage = location?.state?.from_chat === 'storage' ? true : false;

  //   if (!loginInfo.id || isStorage) return
  //   if (inputRef.current) {
  //     inputRef.current.value = '';
  //     searchRef.current = "";
  //   }

  //   // 사용자 입력값 전송시 입력 창 높이 초기화
  //   handleResizeHeight();

  //   const abortController = new AbortController();
  //   const timeoutId = setTimeout(() => {
  //     abortController.abort();

  //   }, 30000); // 30초 타임아웃 설정

  //   try {
  //     const formData = state;
  //     const commonHeaders = {
  //       "Content-Type": "application/json",
  //       "accept": "application/json",
  //       "Access-Control-Allow-Origin": "*",
  //     };

  //     if (url === URLS.CLARIO_EVALUATION) {
  //       const filterArr = state?.query_type_list?.filter(item => item !== null);
  //       const lastIdx = filterArr?.length - 1;
  //       let cnt = (filterArr[lastIdx] === 'mn' && filterArr[lastIdx - 1] === 'mn') ||
  //         (filterArr[lastIdx] === 'end' && filterArr[lastIdx - 1] === 'end') ? 2 : 4;
  //       const checkFinish = (filterArr[lastIdx] === 'end');
  //       setIsFinish(checkFinish);
  //       const formData = {
  //         messages: [...state.messages.slice(-cnt)],
  //         last_session: checkFinish
  //       };

  //       const config = {
  //         method: 'POST',
  //         headers: commonHeaders,
  //         body: JSON.stringify(formData),
  //         payload: JSON.stringify({
  //           engine: "curie",
  //           temperature: 0.75,
  //           top_p: 0.95,
  //           max_tokens: 3,
  //           stream: false,
  //           stop: ["\n\n"],
  //         }),
  //       };

  //       const res = await fetch(url, config);

  //       if (res.status !== 200 && res.status !== 201 && url !== URLS.CLARIO_EVALUATION) {
  //         handleFetchError();
  //         return
  //       }
  //     } else {

  //       setTimer(DEADLINE);
  //       setFetching(true);
  //       setIsFreeScroll(false);
  //       setIsStartInterview(true)
  //       const config = {
  //         method: 'POST',
  //         headers: commonHeaders,
  //         body: JSON.stringify(formData),
  //         timeout: 10000,
  //         signal: abortController?.signal,
  //         payload: JSON.stringify({
  //           engine: "curie",
  //           prompt: state,
  //           temperature: 0.75,
  //           top_p: 0.95,
  //           max_tokens: 3,
  //           stream: true,
  //           stop: ["\n\n"],
  //         }),
  //       };

  //       const res = await fetch(url, config);
  //       console.log(res)

  //       if (!res || !res.body) {
  //         triggerRef.current = false;
  //         addRef.current = false;
  //         restartRef.current = false;
  //         handleFetchError();
  //         return;
  //       }

  //       const reader = ndjsonStream(res.body).getReader();
  //       let hasReceivedData = false;

  //       while (true) {
  //         let result;
  //         try {
  //           result = await reader.read();
  //         } catch (readError) {
  //           handleFetchError();
  //           break;
  //         }

  //         const { done, value } = result;
  //         console.log(result)
  //         /**
  //        * 네트워크 에러시 처리
  //        */
  //         if (done === false) {
  //           hasReceivedData = true;
  //         }

  //         if (done) {
  //           if (!hasReceivedData) {
  //             handleFetchError('네트워크 오류가 발생했습니다. 다시 시도해주세요.');
  //           }
  //           break;
  //         } else {
  //           if (value !== '') {
  //             const jsonData = await delayLoop(value);
  //             console.log(jsonData)
  //             const isLast = jsonData.last_result;
  //             if (!isLast) {
  //               handleNonLastResult(jsonData);
  //             } else {
  //               handleLastResult(jsonData);
  //             }
  //           }
  //         }
  //       }
  //     }
  //   } catch (error) {
  //     handleFetchError();
  //   } finally {
  //     clearTimeout(timeoutId);
  //     setIsVoiceMode(false);
  //     triggerRef.current = false;
  //     addRef.current = false;
  //     restartRef.current = false;
  //   }
  // };

  // 에러 함수 호출

  const fetchData = async (url) => {
    // Reset input field if available
    const isStorage = location?.state?.from_chat === "storage" ? true : false;

    if (!isValidLogin() || isStorage) return;
    if (inputRef.current) {
      inputRef.current.value = "";
      searchRef.current = "";
    }

    // 사용자 입력값 전송시 입력 창 높이 초기화
    handleResizeHeight();

    const abortController = new AbortController();
    const timeoutId = setTimeout(() => {
      abortController.abort();
      // 타임아웃 발생 시 사용자에게 알림 또는 적절한 에러 처리
      handleFetchError("요청 시간이 초과되었습니다. 다시 시도해주세요.");
    }, 30000); // 30초 타임아웃 설정

    try {
      // CLARIO_EVALUATION 경로 처리는 기존 로직 유지
      if (url === URLS.CLARIO_EVALUATION) {
        const filterArr = state?.query_type_list?.filter(
          (item) => item !== null
        );
        const lastIdx = filterArr?.length - 1;
        let cnt =
          (filterArr[lastIdx] === "mn" && filterArr[lastIdx - 1] === "mn") ||
          (filterArr[lastIdx] === "end" && filterArr[lastIdx - 1] === "end")
            ? 2
            : 4;
        const checkFinish = filterArr[lastIdx] === "end";
        setIsFinish(checkFinish);
        const formDataForEval = {
          // 변수명 충돌 방지: formData -> formDataForEval
          messages: [...state.messages.slice(-cnt)],
          last_session: checkFinish,
        };
        const commonHeaders = {
          "Content-Type": "application/json",
          accept: "application/json",
          "Access-Control-Allow-Origin": "*",
        };
        const configEval = {
          // 변수명 충돌 방지: config -> configEval
          method: "POST",
          headers: commonHeaders,
          body: JSON.stringify(formDataForEval),
          // payload는 fetch API의 표준 옵션이 아닙니다. 이 부분이 커스텀 옵션이라면 제거하거나 처리해야 합니다.
          // 서버에서 payload를 따로 처리하는 경우에만 유효합니다. 일반적으로 body에 모든 데이터를 담습니다.
          // payload: JSON.stringify({
          //   engine: "curie",
          //   temperature: 0.75,
          //   top_p: 0.95,
          //   max_tokens: 3,
          //   stream: false,
          //   stop: ["\n\n"],
          // }),
        };

        const res = await fetch(url, configEval); // configEval 사용

        if (res.status !== 200 && res.status !== 201) {
          handleFetchError();
          return;
        }
        await res.json();
      } else {
        setTimer(DEADLINE);
        setFetching(true);
        setIsFreeScroll(false);
        setIsStartInterview(true);

        const configStream = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },
          body: JSON.stringify(state),
          signal: abortController?.signal,
        };

        const res = await fetch(url, configStream);

        if (!res.ok) {
          // res.status !== 200 대신 res.ok를 사용하여 2xx 응답 코드 검사
          console.error("API 응답 오류:", res.status, res.statusText);
          handleFetchError(`서버 오류 발생: ${res.status} ${res.statusText}`);
          triggerRef.current = false;
          addRef.current = false;
          restartRef.current = false;
          return;
        }

        if (!res.body) {
          console.error("응답 body가 없습니다.");
          triggerRef.current = false;
          addRef.current = false;
          restartRef.current = false;
          handleFetchError("네트워크 오류: 응답 본문을 읽을 수 없습니다.");
          return;
        }

        // ndjsonStream 사용 전, res.body가 ReadableStream인지 확인 (타입 안정성)
        if (!(res.body instanceof ReadableStream)) {
          console.error("응답 body가 ReadableStream이 아닙니다.");
          handleFetchError("스트림 응답 형식이 올바르지 않습니다.");
          return;
        }

        const reader = ndjsonStream(res.body).getReader();
        let hasReceivedMeaningfulData = false; // 빈 문자열이 아닌 유의미한 데이터를 받았는지 여부

        while (true) {
          let result;
          try {
            result = await reader.read();
          } catch (readError) {
            console.error("스트림 읽기 오류:", readError);
            handleFetchError("데이터 스트림을 읽는 중 오류가 발생했습니다.");
            break; // 오류 발생 시 루프 종료
          }

          const { done, value } = result;

          if (done) {
            if (!hasReceivedMeaningfulData) {
              // 스트림이 종료되었지만 유의미한 데이터를 전혀 받지 못했을 경우
              handleFetchError(
                "네트워크 오류: 데이터를 받지 못하고 스트림이 종료되었습니다."
              );
            }
            break; // 스트림 종료 시 루프 종료
          }

          if (value) {
            let jsonData;
            try {
              jsonData = await delayLoop(value);

              if (typeof jsonData === "object" && jsonData !== null) {
                hasReceivedMeaningfulData = true;
                const isLast = jsonData.last_result;

                if (isLast === undefined) {
                  console.warn(
                    "경고: 응답 데이터에 'last_result' 필드가 없습니다.",
                    jsonData
                  );
                  handleNonLastResult(jsonData);
                } else if (!isLast) {
                  handleNonLastResult(jsonData);
                } else {
                  handleLastResult(jsonData);
                }
              } else {
                console.warn(
                  "경고: 파싱된 데이터가 유효한 JSON 객체가 아닙니다.",
                  jsonData
                );
              }
            } catch (parseError) {
              console.error(
                "데이터 파싱 중 오류 발생:",
                parseError,
                "원본 값:",
                value
              );
            }
          } else {
            // console.log("스트림에서 빈(null/undefined) 값 수신:", value);
          }
        }
      }
    } catch (error) {
      console.error("Fetch 요청 중 치명적인 오류 발생:", error);
      if (error.name === "AbortError") {
        console.warn("Fetch 요청이 취소되었습니다 (AbortError).");
      } else {
        handleFetchError("네트워크 연결 또는 서버 응답 문제 발생.");
      }
    } finally {
      clearTimeout(timeoutId);
      setIsVoiceMode(false);
      triggerRef.current = false;
      addRef.current = false;
      restartRef.current = false;
    }
  };

  const handleFetchError = (customErrorMessage = "다시 시도해주세요.") => {
    setFetching(false);
    setIsFinish(false);
    setHistory((prev) => {
      const copy = [...prev];
      const myIdx = copy.length === 0 ? 0 : copy.length - 1;
      copy[myIdx].action = "error";
      copy[myIdx].answer = customErrorMessage;
      return copy;
    });
  };

  // 스트림 데이터 핸들링
  const handleNonLastResult = (jsonData) => {
    const myIdx = history.length === 0 ? 0 : history.length - 1;
    setWordLng((prev) => ((prev + 1) % 10 === 0 ? prev + 1 : prev));
    setHistory((prev) => {
      const copy = [...prev];
      const newAnswer =
        copy[myIdx]?.answer !== undefined && copy[myIdx]?.answer !== null
          ? copy[myIdx]?.answer + jsonData.content
          : jsonData?.content;
      copy[myIdx] = {
        ...copy[myIdx],
        answer: newAnswer,
        action: jsonData?.action,
        last_result: jsonData?.last_result,
        id: jsonData?.response_id,
        response_id: jsonData?.response_id ? jsonData?.response_id : "",
        response_time: state.messages[state.messages.length - 1].response_time,
      };
      return copy;
    });
  };

  // 스트림 종료시 추가 데이터 핸들링
  const handleLastResult = (jsonData) => {
    dispatch({
      type: "UPDATE_SOCRATES",
      payload: {
        response_id: jsonData?.response_id,
        response: jsonData?.response,
        query_type: jsonData?.query_type,
        query_type_list: [...jsonData?.query_type_list],
        question_count: jsonData?.question_count,
        followup_count: jsonData?.followup_count,
      },
    });

    timerRef.current = jsonData?.query_type === "end" ? false : true;
    deliverResult(jsonData);
    setIsFinish(!timerRef.current);

    const params = location.pathname.split("/")[2];

    if (history.length === 1) {
      updateTitle(Number(params) ? Number(params) : params, jsonData.response);
    }
  };

  // 나만의 소크라테스 만들기 값 저장
  const handleSubmitForm = async (formdata) => {
    // const data = checkGroupId()
    const params = location.pathname.split("/")[2];

    const reqData = {
      group_id: Number(params),
      file_content: formdata.special_request,
      s_form_kind: formdata.interview_category,
      s_form_inter_area: formdata.favorite_topic,
      like_topic: formdata.favorite_subject,
      apply_org: formdata.interviewing_institution,
      style: formdata.user_input,
      exp_title: "",
      main_max_count: 10,
      fu_max_count: 1,
      show_result: true,
    };
    const resForm = await touchAPI("POST", URLS.GET_FORM_LIST, reqData);
    if (resForm) {
      const startData = {
        // user_pk: user.id,
        group_id: Number(params),
      };
      dispatch({
        type: "CREATE_FORM",
        payload: {
          interview_info: formdata,
        },
      });
      const newState = {
        is_writed: true,
        his_cnt: 0,
        show_result: true,
      };
      triggerRef.current = true;
      const resStart = await touchAPI("POST", URLS.START_INTERVIEW, startData);
      if (resStart) {
        setHistory((prev) => {
          const copy = [...prev];
          copy.push({
            input_text: "",
            answer: "",
            action: "chat ",
            response_id: "",
          });
          return copy;
        });
        navigation(location.pathname, {
          state: { ...location.state, ...newState },
          replace: true,
        });
        setIsStartInterview(true);
      }
      //  else if (resStart.status === 404) {
      //   setAlertSetting(prev => ({
      //     ...prev,
      //     alertTxt: `이용 가능 횟수: 0개\n이용중인 상품이 없습니다.\n 결제페이지로 이동하시겠습니까?`,
      //     double: true,
      //     btnTxt: '이동하기',
      //     onConfirm: () => {
      //       clearState();
      //       navigation('/settings/products', { state: { is_completed: false, is_writed: false, from_chat: null, his_cnt: 0 } })
      //     }
      //   }))
      // }
    }
  };

  /**
   * backend 통신
   * @param {string: API method} method
   * @param {string: API endpoint} url
   * @param {object: API request data} data
   */
  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data);
      const resData = await response?.json();

      if (response.status === 401) {
        setIsLogin(true);
        return;
      } else if (response.status === 400 || response.status === 405) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
        }));
        return;
      } else if (response.status === 403) {
        const txt =
          response.status === 403
            ? "당월 질문 횟수가 소진되었습니다.\n 결제페이지로 이동하시겠습니까?"
            : "무료 질문 횟수가 소진되었습니다.\n 결제페이지로 이동하시겠습니까?";
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: txt,
          onConfim: () => {
            setUser((prev) => ({
              ...prev,
              tutor_cnt: 0,
            }));
            navigation("/settings/products", {
              state: { is_completed: false, is_writed: false, target: null },
            });
          },
        }));
        return;
      } else if (response.status === 500) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: "다시 시도해주세요.",
        }));
        return;
      } else {
        return resData;
      }
    } catch (err) {
      console.error("API 요청 중 오류 발생:", err);
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    }
  };

  const handleSelect = (e) => {
    let targetValue = e.value;
    setUser((prev) => ({
      ...prev,
      tone: e.value,
    }));
    dispatch({
      type: "SELECT_PERSONA",
      payload: {
        persona: targetValue,
      },
    });
  };

  useEffect(() => {
    if (user.tone) {
      dispatch({
        type: "SELECT_PERSONA",
        payload: {
          persona: user.tone,
        },
      });
    }
    // if(user.id && paramId) {
    //   dispatch({
    //     type: "UPDATE_USERINFO",
    //     payload: {
    //       user_id: user.id,
    //       group_id: Number(paramId)
    //     }
    //   })
    // }
  }, [user.tone, user.id, paramId]);

  const clearCustomData = () => {
    setIsAddingMode(false);
    addRef.current = false;
    triggerRef.current = false;
    dispatch({
      type: "RESET_FORM",
    });
  };

  const checkKeyType = (e) => {
    const keyName = e.key;
    const isEmpty = EMPTY.test(inputRef.current.value);
    if (e.nativeEvent.isComposing || isEmpty) return;
    if (keyName === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmitQuestion(e);
    }
  };

  const [timer, setTimer] = useState(0);

  const [uploading, setUploading] = useState(false);

  const selectInterviewMode = async (e) => {
    if (!isValidLogin()) {
      moveToLogin();
      return;
    }
    setIsFinish(false);
    if (user.socra_cnt === 0) {
      setIsOpenTicketAlert(true);
      return;
    }
    const data = checkGroupId();
    // setTartgetURL(URLS.CLARIO_GENERAL)
    setTartgetURL(URLS.CLARIO);
    if (data.params) {
      const reqData = {
        clario_prompt: e.clario_prompt,
        group_id: data.params,
        file_content: e?.file_content,
        like_topic: e.favorite_subject,
        exp_title: e.title,
        is_completed: false,
        main_max_count: e.main_max_count,
        fu_max_count: e.fu_max_count,
        show_result: e.show_result,
        user_id: user?.id || "",
        persona: user?.tone || "선생님 말투",
      };
      const resForm = await touchAPI("POST", URLS.GET_FORM_LIST, reqData);
      if (resForm) {
        const startData = {
          // user_pk: user.id,
          group_id: Number(data.params),
        };
        const url = {
          pathname: data.pathname,
          params: data.params,
          state: {
            target: "group",
            is_writed: true,
            is_completed: false,
            his_cnt: 0,
          },
        };
        // window.localStorage.setItem('url', JSON.stringify(url))
        const newState = {
          is_writed: true,
          show_result: e.show_result,
        };
        navigation(location.pathname, {
          state: { ...location.state, ...newState },
          replace: true,
        });
        const resStart = await touchAPI(
          "POST",
          URLS.START_INTERVIEW,
          startData
        );
        if (resStart) {
          dispatch({
            type: "SELECT_FORM",
            payload: {
              special_request: e.clario_prompt,
              favorite_subject: e.favorite_subject,
              favorite_topic: e.title,
              user_input: e.file_content ? e.file_content : "",
              main_max_count: e.main_max_count,
              fu_max_count: e.fu_max_count,
            },
          });
          triggerRef.current = true;
          setIsStartInterview(true);
          // navigation(`/socrates/${data.params}`, { state: { target: 'group', is_completed: false, is_writed: true } })
        }
      }
    } else {
      const reqData = {
        // user_pk: user.id,
        title: e.title ? e.title : "새 대화",
      };

      const resData = await touchAPI("POST", URLS.EDIT_GROUP_LIST, reqData);

      if (resData.id) {
        // special_request: e.explain,
        // favorite_subject: e.favorite_subject,
        // favorite_topic: e.title,
        // user_input: e.file_content ? e.file_content : '',
        // main_max_count: e.main_max_count,
        //   fu_max_count: e.fu_max_count,

        const reqData = {
          group_id: resData.id,
          file_content: e.file_content,
          clario_prompt: e.clario_prompt,
          style: e.explain,
          like_topic: e.favorite_subject,
          exp_title: e.title,
          is_completed: false,
          main_max_count: e.main_max_count ? e.main_max_count : 10,
          fu_max_count: e.fu_max_count,
          show_result: e.show_result,
          user_id: user?.id || "",
          persona: user.tone || "선생님 말투",
        };
        const resForm = await touchAPI("POST", URLS.GET_FORM_LIST, reqData);
        if (resForm) {
          const startData = {
            // user_pk: user.id,
            group_id: Number(resData.id),
          };
          const resStart = await touchAPI(
            "POST",
            URLS.START_INTERVIEW,
            startData
          );
          if (resStart) {
            triggerRef.current = true;

            navigation(`/socrates/${resData.id}`, {
              state: {
                from_chat: "group",
                his_cnt: 0,
                is_completed: false,
                is_writed: true,
                show_result: e.show_result,
              },
            });
          }
        }
      }
    }
  };

  const startInterview = async (e) => {
    if (!isValidLogin()) {
      moveToLogin();
      return;
    }
    if (user.socra_cnt === 0) {
      setIsOpenTicketAlert(true);
      return;
    }
    const data = checkGroupId();
    if (data.params) {
      // formRef.current = true
    } else {
      const reqData = {
        // user_pk: user.id,
        title: "새 대화",
      };
      const resData = await touchAPI("POST", URLS.EDIT_GROUP_LIST, reqData);
      if (resData.id) {
        navigation(`/socrates/${resData.id}`, {
          state: {
            from_chat: resData.from_chat,
            his_cnt: 0,
            is_writed: false,
            is_completed: false,
            show_result: true,
          },
        });
      }
    }
    setIsAddingMode(true);
  };

  const countLeftTime = (time) => {
    let leftTime = 120 - time;
    setTimer(leftTime);
  };
  const handleSubmitQuestion = (e) => {
    e.preventDefault();
    const isEmpty = EMPTY.test(inputRef.current.value);
    if (fetching || isEmpty) return;
    setWordLng(history.length);
    const inputValue = inputRef.current.value;
    if (inputValue !== "") {
      timerRef.current = false;
      setIsUpdate(!isUpdate);
      triggerRef.current = true;
      setIsStartInterview(true);
      setHistory((prev) => {
        const copy = [...prev];
        copy.push({
          input_text: inputValue,
          answer: "",
          action: "chat",
          response_id: "",
        });
        return copy;
      });
    }
  };

  const updateHistory = async (url, id) => {
    if (Number.isNaN(id)) return;
    const resData = await touchAPI("GET", url, `/${id}`);
    if (resData) {
      const chattingList = resData.chat_list;
      if (chattingList.length === 0) {
        triggerRef.current = true;
        setHistory([]);
      } else {
        setHistory((prev) => {
          const copy = [...chattingList];
          const newCopy = copy.map((item) => ({
            id: item.response_id,
            response_id: item.response_id,
            last_result: item.last_result,
            recommended_questions: item.recommended_questions,
            latency: item.latency,
            input_text: item.input_text,
            answer: item.response,
            images: item.images,
            action: item.action,
            sub_action: item.sub_action,
            from_chat: item.from_chat,
            question_count: item.question_count,
            followup_count: item.followup_count,
            query_type: item.query_type,
          }));
          return newCopy;
        });
      }
    }
  };

  const deliverResult = async (data) => {
    const jsonData = checkGroupId();
    const lastIdx = state.messages.length - 1;

    if (state.messages[lastIdx]?.query_type === "end") {
      setList((prevList) =>
        prevList.map((item) =>
          item.id === Number(jsonData.params)
            ? { ...item, is_completed: true }
            : item
        )
      );
    }
    setIsUpdate(!isUpdate);
    if (jsonData) {
      const newData = { ...data };
      const groupId = Number(jsonData.params);
      const index = data?.query_type_list.length - 2;
      newData.group_id = groupId;
      newData.input_text = state?.messages[lastIdx]?.content;
      newData.response_time = 120 - timer;
      const resData = await touchAPI("POST", URLS.CHAT_HISTORY, newData);
      setFetching(false);
      if (resData) {
        if (resData.detail) {
        } else {
        }
      }
    }
  };

  const handleFinish = async (e) => {
    const targetId = e.target.id;
    const targetName = e.target.dataset.mode;

    if (targetId === "result-page") {
      // 현재 히스토리 엔트리를 /socrates로 대체
      window.history.replaceState(null, "", "/socrates");

      // 그 다음 결과 페이지로 이동
      navigation(`/result/${paramId}`, {
        state: {
          from_chat: targetName === undefined ? "storage" : targetName,
          his_cnt: history?.length,
          is_writed: true,
          is_completed: true,
        },
      });
      const url = {
        pathname: "result",
        params: paramId,
        state: {
          from_chat: targetName,
          is_completed: true,
          is_writed: true,
          his_cnt: history?.length,
        },
      };
      window.localStorage.setItem("url", JSON.stringify(url));
    } else {
      const data = checkGroupId();
      if (data) {
        const id = Number(data?.params);
        const reqData = {
          group_id: id,
        };
        const resData = await touchAPI("POST", URLS.RESTART, reqData);
        if (resData) {
          if (resData) {
            setHistory([]);
          }
          setIsFinish(false);
          dispatch({
            type: "RESTART_INTERVIEW",
          });
          const startData = {
            // user_pk: user.id,
            group_id: id,
          };
          const resStart = await touchAPI(
            "POST",
            URLS.START_INTERVIEW,
            startData
          );
          if (resStart) {
            const url = {
              pathname: "socrates",
              params: id,
              state: {
                from_chat: "group",
                is_completed: false,
                is_writed: true,
                his_cnt: 0,
              },
            };
            // window.localStorage.setItem('url', JSON.stringify(url))
            navigation(`/socrates/${id}`, {
              state: {
                is_completed: false,
                is_writed: true,
                from_chat: "group",
                his_cnt: 0,
                show_result: data?.state?.show_result,
              },
            });
            setList((prevList) =>
              prevList.map((item) =>
                item.id === id ? { ...item, is_completed: false } : item
              )
            );
            triggerRef.current = true;
            restartRef.current = true;
            setIsStartInterview(true);
            // navigation(`/socrates/${resData.id}`, { state: { target: 'group', is_completed: false, is_writed: true } })
          }
        }
      }
    }
  };

  const getPrevFrom = async (id) => {
    const resData = await touchAPI("GET", URLS.GET_FORM_LIST, `/${Number(id)}`);
    if (resData) {
      // triggerRef.current = true
      // if (resData.is_exp) {
      //   setTartgetURL(URLS.CLARIO_GENERAL)
      // }
      dispatch({
        type: "GET_FORM",
        payload: {
          interview_info: {
            special_request: resData.clario_prompt ? resData.clario_prompt : "",
            interview_category: resData.s_form_kind ? resData.s_form_kind : "",
            favorite_topic: resData.s_form_inter_area
              ? resData.s_form_inter_area
              : "",
            interviewing_institution: resData.apply_org
              ? resData.apply_org
              : "",
            favorite_subject: resData.like_topic ? resData.like_topic : "",
            user_input: resData.file_content ? resData.file_content : "",
          },
          main_max_count: resData.main_max_count,
          fu_max_count: resData.fu_max_count,
        },
      });
    }
  };
  const [isToggle, setIsToggle] = useState(false);
  const searchRef = useRef("");
  const setTextFunction = (text, isCollapse = false) => {
    setIsToggle(!isToggle);
    inputRef.current.value = text;
  };

  const [isFinish, setIsFinish] = useState(false); // 면접 완료여부
  const [isShowResult, setIsShowResult] = useState(true);
  // form 작성 유무 확인하여 FORM 호출 및 초기화

  const lastScrollY = useRef(0);
  // 스크롤 이벤트 핸들러
  const handleScroll = () => {
    const currentScrollY = scrollRef.current.scrollTop;

    if (currentScrollY < lastScrollY.current) {
      setIsFreeScroll(true);
    }
    // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // 스크롤 위치가 50px 이상일 때 로고를 숨김
    // if (currentScrollY > 50) {
    //   setIsLogoHidden(true);
    // } else {
    //   setIsLogoHidden(false);
    // }

    // 현재 스크롤 위치를 저장
    lastScrollY.current = currentScrollY;
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, []); // 의존성 배열에 빈 배열을 넣어 처음 렌더링될 때만 실행되도록 설정

  useEffect(() => {
    const prev = checkGroupId();
    const data = location.state;
    const currentId = location.pathname.split("/")[2];
    const isGroupchat = data?.from_chat === "group" ? true : false;

    async function getFormInform() {
      if (fetching) return;
      setIsShowResult(data?.show_result);
      // 면접 폼 생성, 완료되지않은 면접일 때 from 받아오기
      if (data && data?.is_writed && !data?.is_completed) {
        setIsFinish(false);
        getPrevFrom(currentId);
        // if (restartRef.current || prev?.state?.his_cnt === 0) return
        if (restartRef.current || data?.his_cnt === 0) return;
        updateHistory(
          isGroupchat ? URLS.CHAT_HISTORY : URLS.STORAGE_LIST,
          Number(currentId)
        );
        return;
      }
      // 완료된 면접
      if ((data && data?.is_completed) || !isGroupchat) {
        setIsFinish(true);
        triggerRef.current = false;
        timerRef.current = false;
        updateHistory(
          data?.from_chat === "storage" ? URLS.STORAGE_LIST : URLS.CHAT_HISTORY,
          Number(currentId)
        );
        return;
      } else if (data.his_cnt === 0 || !data.is_writed) {
        setIsFinish(false);
        triggerRef.current = false;
        timerRef.current = true;
        if (
          restartRef.current ||
          (prev?.state?.his_cnt === 0 && !prev?.state?.is_writed)
        )
          return;
        setHistory([]);
        return;
      } else if (!currentId) {
        setIsFinish(false);
        triggerRef.current = false;
        timerRef.current = false;
        clearCustomData();
        setHistory([]);
        return;
      } else if (Number(prev?.params) !== Number(currentId)) {
        // setIsStartInterview(false)
        triggerRef.current = false;
        timerRef.current = false;
      }
    }
    getFormInform();

    const prevCount = paramRef.current.split("/").length - 1;
    const currentCount = location.pathname.split("/").length - 1;

    if (paramRef.current !== location.pathname) {
      setIsStartInterview(false);
      setIsFinish(data?.is_completed);
      dispatch({
        type: "RESET_FORM",
      });
      paramRef.current = location.pathname;
      restartRef.current = false;
      // setIsStartInterview(false)

      if (
        (prevCount === currentCount &&
          paramRef.current !== location.pathname) ||
        prevCount > currentCount
      ) {
      }
    }
  }, [location]);

  useLayoutEffect(() => {
    async function startWithForm() {
      const data = location.state;
      const params = location.pathname.split("/")[2];
      const lastIdx = state?.messages?.length - 1;
      if (params && data?.is_writed && state?.messages?.length > 0) {
        // fetch CLARIO only if last valus is user's input
        if (
          state?.messages[lastIdx]?.role === "user" &&
          (state.interview_info.favorite_topic !== "" ||
            state.interview_info.favorite_subject !== "") &&
          data?.his_cnt === 0 &&
          triggerRef.current
        ) {
          if (fetching) return;
          fetchData(targetURL);
          return;
        }
      } else if (
        (params && data?.is_writed && data?.his_cnt === 0) ||
        restartRef.current
      ) {
        // start interview only if there are writed form and history array
        setIsStartInterview(true);
        setHistory((prev) => {
          const copy = [...prev];
          copy.push({
            input_text: "",
            answer: "",
            action: "chat ",
            response_id: "",
          });
          return copy;
        });
      }
    }
    startWithForm();
  }, [state.interview_info, location]);

  useEffect(() => {
    async function getData() {
      const data = location.state;
      const params = location.pathname.split("/")[2];
      if (params) {
        const messageIdx = state?.messages?.length - 1;
        // if (state.messages.length > 1 && state.messages[messageIdx].role === 'user' && (state.interview_info.special_request !== '' || state.interview_info.favorite_topic !== '') && triggerRef.current) {
        if (
          state?.messages?.length > 1 &&
          state?.messages[messageIdx]?.role === "user" &&
          triggerRef.current &&
          !data.is_completed &&
          isStartInterview
        ) {
          fetchData(targetURL);
        }
        if (
          state.messages[messageIdx]?.query_type === "mn" ||
          state?.messages[messageIdx]?.query_type === "end"
        ) {
          fetchData(URLS.CLARIO_EVALUATION);
          // setIsEvaluating(true)
          if (state?.messages[messageIdx]?.query_type === "end") {
            setIsFinish(true);
            setIsStartInterview(false);
          } else {
            setIsFinish(false);
          }
        }
      }
    }
    getData();
  }, [state.messages]);

  useEffect(() => {
    const data = location.state;
    if (
      (state.followup_count === -1 && restartRef.current) ||
      (state.followup_count === -1 && data?.is_writed && data?.his_cnt === 0)
    ) {
      restartRef.current = false;
      fetchData(targetURL);
    }
  }, [state.question_count, state.followup_count]);

  useEffect(() => {
    const lastIdx = history?.length - 1;
    const messageIdx = state?.messages?.length - 1;
    setWordLng(history.length);
    if (restartRef.current) return;
    setIsUpdate(!isUpdate);

    if (location?.state?.add_mode && history.length === 0) {
      setIsAddingMode(true);
    }
    if (history.length > 0) {
      setIsAddingMode(false);
    }
    if (history.length === 1) {
      const newState = {
        his_cnt: history.length,
      };
      navigation(location.pathname, {
        state: { ...location.state, ...newState },
        replace: true,
      });
    }
    if (state?.messages?.length <= 1 && history.length > 0) {
      if (history[history.length - 1].query_type !== "end") {
        timerRef.current = true;
      } else {
        timerRef.current = false;
      }
      const newArray = [];
      let types = [];
      history.forEach((item, idx) => {
        let prevId = "";
        if (idx > 0) {
          prevId = history[idx - 1]?.response_id;
        }
        const userItem = {
          role: "user",
          content: item.input_text ? item.input_text : "",
          response_id: item.response_id ? item.response_id : prevId,
          response_time: item.response_time ? item.response_time : 0,
          query_type: null,
        };
        const assistantItem = {
          role: "assistant",
          content: item.answer,
          response_id: item.response_id ? item.response_id : "",
          response_time: item.response_time ? item.response_time : 0,
          query_type: item.query_type ? item.query_type : null,
        };
        if (!item.answer) {
          newArray.push(userItem);
          return;
        } else {
          newArray.push(userItem, assistantItem);
        }
        const isMainQuestion = item.followup_count === 0 ? "mn" : "fu";
        types.push(null, item?.query_type ? item?.query_type : isMainQuestion);
        if (newArray?.length !== types?.length) {
          types = [];
          newArray.forEach((item) => {
            if (item.role === "user") {
              types.push(null);
            } else {
              if (item?.answer?.length > 200) {
                types.push("mn");
              } else {
                types.push("fu");
              }
            }
          });
        }
      });
      dispatch({
        type: "GET_HISTORY",
        payload: {
          messages: [...newArray],
          query_type_list: [...types],
          question_count: history[lastIdx - 1]?.question_count
            ? history[lastIdx - 1]?.question_count
            : history.length - 1,
          followup_count: history[lastIdx - 1]?.followup_count
            ? history[lastIdx - 1]?.followup_count
            : 0,
        },
      });
      return;
    } else if (state.messages.length !== 1 && history.length > 0) {
      timerRef.current = true;
      const lastItem = history[lastIdx];
      const newArray = [...state.messages];
      let types = state.query_type_list;
      const userItem = {
        role: "user",
        content: lastItem.input_text ? lastItem.input_text : "",
        response_id: lastItem.response_id,
        response_time: lastItem.response_time
          ? lastItem.response_time
          : DEADLINE - timer,
        query_type: null,
      };
      newArray.push(userItem);
      if (
        Array.isArray(state.query_type_list) &&
        state.query_type_list[state.query_type_list?.length - 1] !== null
      ) {
        types.push(null);
      }
      if (newArray?.length !== types?.length) {
        types = [];
        newArray.forEach((item) => {
          if (item.role === "user") {
            types.push(null);
          } else {
            if (item?.answer?.length > 200) {
              types.push("mn");
            } else {
              types.push("fu");
            }
          }
        });
      }
      // if (!userItem.content) return
      triggerRef.current = true;
      dispatch({
        type: "UPDATE_USER",
        payload: {
          messages: newArray,
          query_type_list: types,
        },
      });
      return;
    }
  }, [history.length]);

  useEffect(() => {
    const lastIdx = history?.length - 1;
    const messageIdx = state.messages?.length - 1;
    const inputValue = inputRef?.current?.value;
    if (
      lastIdx >= 0 &&
      timer === 120 &&
      state.messages[messageIdx]?.role === "assistant"
    ) {
      setHistory((prev) => {
        const copy = [...prev];
        copy.push({
          input_text: inputValue ? inputValue : null,
          answer: "",
          action: "chat",
          response_id: "",
          query_type: null,
        });
        return copy;
      });
    }
  }, [timer]);

  const handleStartInterview = (e) => {
    const target = e.target.id;
    if (target === "start") {
      setIsStartInterview(true);
      triggerRef.current = true;
    } else if (target === "stop") {
      setIsStartInterview(false);
    } else {
      handleFinish(e);
    }
  };

  useEffect(() => {
    // 컴포넌트 언마운트 시 실행
    return () => {
      setIsAddingMode(false);
    };
  }, [setIsAddingMode]);

  return (
    <Style>
      <main className="ctn-wrp socrates-wrp">
        <div
          className={`rd-wrp ${
            history?.length === 0 ? "flx-box flx-col" : ""
          } `}
          ref={scrollRef}
        >
          <div
            className={`rd-inr flx-box ${
              (history?.length === 0 && !fetching) ||
              (history?.length === 0 && fetching)
                ? "emp-wrp"
                : ""
            } `}
            style={
              history?.length === 0 && openNav && !isMobile
                ? { padding: 0, width: "70%" }
                : history?.length === 0 && openNav
                ? { padding: 0, width: "calc(100% - 257px)" }
                : null
            }
          >
            <Interview
              history={history}
              fetching={fetching}
              setIsUpdate={setIsUpdate}
              wordLng={wordLng}
              setWordLng={setWordLng}
            />
            {/* 면접 완료시 결과보기/다시 면접보기 버튼 */}
            {history.length !== 0 && isFinish && isShowResult && (
              <ResultButtons
                isFinish={isFinish}
                history={history}
                handleClickButtons={handleFinish}
              />
            )}

            {
              // 소크라테스 메인 화면
              history.length === 0 && !fetching && !isAddingMode ? (
                // (history.length === 0 && !fetching && !formRef.current) ?
                <Home
                  selectInterviewMode={selectInterviewMode}
                  startInterview={startInterview}
                  dispatch={dispatch}
                />
              ) : // 소크라테스 생성 화면
              history.length === 0 && !fetching && isAddingMode ? (
                // : (history.length === 0 && !fetching && formRef.current) ?
                <Form
                  state={state}
                  dispatch={dispatch}
                  setIsAddingMode={setIsAddingMode}
                  clearCustomData={clearCustomData}
                  handleSubmitForm={handleSubmitForm}
                />
              ) : history.length === 0 && fetching && paramId ? (
                <div className="creating-wrp flx-box">
                  <img src={Book} alt="waiting-creaing" />
                  <p>면접이 곧 시작되오니 준비해주세요.</p>
                </div>
              ) : null
            }
          </div>
        </div>
        {!(
          history.length === 0 ||
          isAddingMode ||
          history[0]?.from_chat === "storage" ||
          isFinish
        ) && (
          // !(history.length === 0 || isAddingMode || history[0]?.from_chat === 'storage') && (
          <Input
            timer={DEADLINE}
            fetching={fetching}
            isFocus={isFocus}
            history={history}
            isAddingMode={isAddingMode}
            handleResizeHeight={handleResizeHeight}
            handleStartInterview={handleStartInterview}
            checkKeyType={checkKeyType}
            isFreeScroll={isFreeScroll}
            countLeftTime={countLeftTime}
            setIsFocus={setIsFocus}
            setIsLogin={setIsLogin}
            isStartInterview={isStartInterview}
            isUpdate={isUpdate}
            setIsUpdate={setIsUpdate}
            isNewTime={timerRef.current && isStartInterview}
            setIsNewTime={handleTimer}
            isFinish={!timerRef.current}
            inputRef={inputRef}
            handleSubmitQuestion={handleSubmitQuestion}
            handleSelect={handleSelect}
            fetchData={() => fetchData(targetURL)}
            isVoiceMode={isVoiceMode}
            setIsVoiceMode={setIsVoiceMode}
            setTextFunction={setTextFunction}
            searchRef={searchRef}
          />
        )}

        {isLogin && <LoginModal />}
      </main>
    </Style>
  );
};
export default Socrates;

const Style = styled.div`
  @media screen and (min-width: 1024px) {
    height: 100%;
  }
  @media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    height: 100%;
    .inp-wrp {
      padding: ${(props) => (props.open ? "0 12% 0% 15%" : "0 10% 0% 10%")};
    }
  }
  @media screen and (max-width: 768.98px) {
    // height: calc(100% - 120px);
    height: 100%; // footer 제거로 높이 조절
    .inp-wrp {
    }
  }
`;
